import { Button, Col, Input, Row, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import {
  displayFormattedDate,
  formatCurrency,
  isEmpty,
} from "../../../generalFunctions";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/table/TableComponent";
import PrintPdfModal from "../../common/PrintPdfModal";
import {
  EditOutlined,
  EyeOutlined,
  PrinterOutlined,
} from "@ant-design/icons";

function OnAccountPaymentTable() {
  const columns = [
    {
      title: "Payment Number",
      dataIndex: "id",
      width: "100px",
    },
    {
      title: "Account Name",
      dataIndex: "accountName",
    },
    {
      title: "Payment Date",
      dataIndex: "paymentDate",
      render: (text) => displayFormattedDate(text),
    },
    {
      title: "Voucher Type",
      dataIndex: "voucherType",
    },
    {
      title: "Narration",
      dataIndex: "narration",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (text) => formatCurrency(text)
    },
    {
      title: "Action",
      key: "action",

      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => editRecord(record)}>
            <EditOutlined/>
          </Button>
          <Button size="small" onClick={() => editRecord(record, true)}>
            <EyeOutlined/>
          </Button>
          <Button size="small" onClick={() => handlePrint(record)}>
            <PrinterOutlined/>
          </Button>
        </Space>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    "/onAccountPayment",
    null,
    API_METHODS.GET
  );

  const [tableData, setTableData] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [visiblePrint, setVisiblePrint] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();

  useEffect(() => {
    getRequest(null, API_METHODS.GET, `/onAccountPayment?pageNumber=${1}`);
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    setTableData(data);
    setTotalRecords(data && data.length > 0 ? data[0].count : 0);
  }, [responseData]);

  const editRecord = (record, isViewOnly = false) => {
    if (isViewOnly) {
      navigate("/portal/onAccountPayment/view", {
        state: { on_account_payment_id: record.id, isViewOnly: isViewOnly },
      });
    } else {
      navigate("/portal/onAccountPayment/edit", {
        state: { on_account_payment_id: record.id, isViewOnly: isViewOnly },
      });
    }
  };

  const onOnAccountPaymentSearch = (id) => {
    if (!isEmpty(id))
      navigate("/portal/onAccountPayment/view", {
        state: { on_account_payment_id: id, isViewOnly: false },
      });
  };

  const onRowSelectChange = (newSelectedRowKeys, records) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(records);
  };

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    onChange: onRowSelectChange,
  };

  const onPaginationChange = (page) => {
    getRequest(
      null,
      API_METHODS.GET,
      `/onAccountPayment?pageNumber=${page.current}`
    );
    setCurrentPage(page.current);
  };

  const handlePrint = (record) => {
    const flag = visiblePrint ? false : true;
    record && setSelectedRecord(record);
    setVisiblePrint(flag);
  };

  return (
    <>
      <Row>
        <Col span={6}>
          <Typography.Title level={5}>On Account Payments</Typography.Title>
        </Col>
        <Col span={18}>
          <Space style={{ marginBottom: 10, float: "right" }}>
            <Input.Search
              placeholder="On Account Payment Number"
              allowClear
              enterButton="Search"
              onSearch={onOnAccountPaymentSearch}
            />
            <Button>
              <Link to="add">Add On Account Payment</Link>
            </Button>
            <Button
              type="primary"
              //onClick={handlePrint}
              disabled={selectedRows.length === 0}
            >
              Print Selected Payments
            </Button>
          </Space>
        </Col>
      </Row>
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        rowSelection={rowSelection}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />

      {visiblePrint && (
        <PrintPdfModal
          visible={visiblePrint}
          data={selectedRows.length !== 0 ? selectedRows : [selectedRecord]}
          title={"Payment Voucher"}
          close={handlePrint}
          pdfType="onAccount"
        />
      )}
    </>
  );
}

export default OnAccountPaymentTable;
